import React, { useState } from 'react';
import styles from './Emitir.module.css';
import CampoMoeda from '../../../componentes/CampoMoeda';

/* Valores — reduzido ao que muda de nota pra nota.
   Saíram da tela:
   - descontos, info. complementares, tributação federal e valor aproximado
     dos tributos -> viraram ícones no cabeçalho;
   - regime especial de tributação -> nenhum cliente daqui se enquadra;
   - alíquota do ISS -> no Simples Nacional o ISS é apurado pelo regime, o
     campo não entra na nota (e a DPS recusa se vier);
   - retenção do ISS -> só aparece pra cliente marcado como "ISS flexível";
     nos demais é sempre "não" e perguntar seria ruído.
   As retenções federais são calculadas a partir dos padrões do cadastro. */

function moeda(v) {
  return Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

function EtapaValores({ dados, set, competencia, onCompetencia, issFlexivel, simplesNacional, retencoes }) {
  const mostrarAliquota = !simplesNacional;
  const [competenciaLivre, setCompetenciaLivre] = useState(false);

  return (
    <div className={styles.etapa}>
      <section className={styles.secao}>
        <div className={styles.linhaCampos}>
          {/* data e valor em campos curtos: cabem lado a lado e campo longo
              pra número de 4 dígitos fica estranho */}
          <div className={styles.campo}>
            <span className={styles.rotulo}>Competência *</span>
            {/* competência é sempre o dia da nota: travada. Dois toques
                rápidos destravam (sem aviso na tela, de propósito) */}
            <input className={`${styles.entrada} ${styles.entradaCurta}`} type="date"
              value={competencia} readOnly={!competenciaLivre} tabIndex={competenciaLivre ? 0 : -1}
              style={competenciaLivre ? undefined : { background: '#f4f7fb', cursor: 'default' }}
              onDoubleClick={() => setCompetenciaLivre(true)}
              onKeyDown={e => { if (!competenciaLivre) e.preventDefault(); }}
              onChange={e => { if (competenciaLivre) onCompetencia(e.target.value); }} />
          </div>
          {/* unitário e quantidade só pro serviço do fornecedor marcado com
              "informar quantidade" -- quase ninguém usa, então não fica pra todos */}
          {dados.usaQuantidade && (<>
          {/* unitário × quantidade só ajudam a chegar no valor do serviço: não
              vão pro XML nem pro PDF. Sem quantidade, o unitário acompanha o
              valor do serviço. */}
          <div className={styles.campo}>
            <span className={styles.rotulo}>Valor unitário</span>
            <CampoMoeda className={`${styles.entrada} ${styles.entradaCurta}`} placeholder="0,00"
              value={Number(dados.quantidade) > 0 ? (dados.valorUnitario ?? '') : dados.valorServico}
              onChange={v => {
                const u = v;
                const q = Number(dados.quantidade);
                set('valorUnitario', u);
                set('valorServico', q > 0 && u !== '' ? String(Math.round(Number(u) * q * 100) / 100) : u);
              }} />
          </div>
          <div className={styles.campo}>
            <span className={styles.rotulo}>Quantidade</span>
            <input className={`${styles.entrada} ${styles.entradaMini}`} type="number" step="any" min="0" placeholder="vazio = 1"
              value={dados.quantidade ?? ''}
              onChange={e => {
                const q = e.target.value;
                const u = Number(dados.quantidade) > 0 ? dados.valorUnitario : dados.valorServico;
                set('quantidade', q);
                set('valorUnitario', u);
                if (u !== '' && u != null) set('valorServico', Number(q) > 0 ? String(Math.round(Number(u) * Number(q) * 100) / 100) : String(u));
              }} />
          </div>
          </>)}
          <div className={styles.campo}>
            <span className={styles.rotulo}>Valor do serviço *</span>
            <CampoMoeda className={`${styles.entrada} ${styles.entradaCurta}`} value={dados.valorServico}
              placeholder="0,00" onChange={v => { set('quantidade', ''); set('valorServico', v); }} />
          </div>

          {mostrarAliquota && (
            <div className={styles.campo}>
              <span className={styles.rotulo}>Alíquota do ISS (%)</span>
              <input className={`${styles.entrada} ${styles.entradaCurta}`} type="number" step="0.01" min="0"
                value={dados.aliquotaIss}
                onChange={e => set('aliquotaIss', e.target.value)} />
            </div>
          )}

          {issFlexivel && (
            <div className={styles.campo}>
              <span className={styles.rotulo}>Há retenção do ISSQN pelo tomador?</span>
              <div className={styles.radios}>
                <label className={styles.radio}>
                  <input type="radio" checked={!dados.reterIss}
                    onChange={() => set('reterIss', false)} /> Não
                </label>
                <label className={styles.radio}>
                  <input type="radio" checked={!!dados.reterIss}
                    onChange={() => set('reterIss', true)} /> Sim
                </label>
              </div>
            </div>
          )}
        </div>

        {/* valores adicionais (do cadastro do tomador): somam no total da nota e
            aparecem à parte no corpo */}
        <div style={{ marginTop: 10 }}>
          {(dados.adicionais || []).map((a, i) => (
            <div key={i} style={{ display: 'flex', gap: 8, marginTop: 6, alignItems: 'center' }}>
              <input className={styles.entrada} placeholder={`Valor adicional ${i + 1}`} value={a.rotulo || ''}
                onChange={e => set('adicionais', dados.adicionais.map((x, j) => (j === i ? { ...x, rotulo: e.target.value } : x)))} />
              <CampoMoeda className={`${styles.entrada} ${styles.entradaCurta}`} placeholder="0,00" value={a.valor ?? ''}
                onChange={v => set('adicionais', dados.adicionais.map((x, j) => (j === i ? { ...x, valor: v } : x)))} />
              <button type="button" className={styles.btnIcone} title="Tirar" onClick={() => set('adicionais', dados.adicionais.filter((_, j) => j !== i))}>×</button>
            </div>
          ))}
          {(dados.adicionais || []).length < 3 && (
            <button type="button" className={styles.btnSecundario} style={{ marginTop: 6 }}
              onClick={() => set('adicionais', [...(dados.adicionais || []), { rotulo: '', valor: '' }])}>+ Valor adicional</button>
          )}
          {(dados.adicionais || []).some(a => Number(a.valor) > 0) && (
            <p className={styles.dica} style={{ marginTop: 6 }}>
              Total da nota: <strong>{(Number(dados.valorServico || 0) + dados.adicionais.reduce((t, a) => t + Number(a.valor || 0), 0)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong>
            </p>
          )}
        </div>

        {/* o que o cadastro manda calcular sozinho aparece aqui, pra não
            ficar retenção invisível entrando na nota */}
        {retencoes.length > 0 && Number(dados.valorServico) > 0 && (
          <div className={styles.retencoesCalculadas}>
            {retencoes.map(r => (
              <span key={r.rotulo} className={styles.retencaoItem}>
                {r.rotulo}: <strong>{moeda(r.valor)}</strong>
                <span className={styles.retencaoOrigem}>({r.origem})</span>
              </span>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

export default EtapaValores;
